var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38462 5.30769C8.38462 4.96782 8.66013 4.69231 9 4.69231C9.33987 4.69231 9.61539 4.96782 9.61539 5.30769V10.8462C9.61539 11.186 9.33987 11.4615 9 11.4615C8.66013 11.4615 8.38462 11.186 8.38462 10.8462V5.30769ZM9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17ZM9 15.7692C12.7385 15.7692 15.7692 12.7385 15.7692 9C15.7692 5.26146 12.7385 2.23077 9 2.23077C5.26146 2.23077 2.23077 5.26146 2.23077 9C2.23077 12.7385 5.26146 15.7692 9 15.7692ZM9 14.3077C8.66013 14.3077 8.38462 14.0322 8.38462 13.6923C8.38462 13.3524 8.66013 13.0769 9 13.0769C9.33987 13.0769 9.61539 13.3524 9.61539 13.6923C9.61539 14.0322 9.33987 14.3077 9 14.3077Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1b13eaa3d79e4ac23f4077fb73eb1540.svg";
export { ForwardRef as ReactComponent };